module.exports = ".content{display:flex;flex-direction:column}\n"